<template>
  <div class="home text-center">
    <LoginForm/>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginForm from '@/components/LoginForm.vue'

export default {
  name: 'home',
  components: {
    LoginForm
  }
}
</script>
<style lang="scss" scoped>
  .home {
    height: 100vh;
    background-image: url('../assets/bg-img.jpg');
    background-size:cover;
    background-position: center;
    padding-top: 20vh;
  }
</style>

